import { useEffect, useRef, useState } from "react";
import { CARD_TYPES, SPECIAL_CARD_TYPES, SUPERTYPES, composeTypeLine, parseTypeLine } from "@/lib/mtg";

function Chips({ label, options, selected, onToggle, testid }) {
  return (
    <div>
      <span className="field-label">{label}</span>
      <div className="flex flex-wrap gap-1.5">
        {options.map((o) => {
          const on = selected.includes(o);
          return (
            <button key={o} type="button" onClick={() => onToggle(o)} aria-pressed={on} data-testid={`${testid}-${o.toLowerCase()}`}
              className={`rounded-full border px-2.5 py-0.5 text-xs transition-colors duration-200 ${on ? "border-amber-400 bg-amber-500/20 text-amber-100" : "border-[#2A3447] text-slate-400 hover:border-amber-700 hover:text-slate-200"}`}>
              {o}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export function TypeLineBuilder({ value, onChange, prefix }) {
  const [parts, setParts] = useState(() => parseTypeLine(value));
  const last = useRef(value);
  useEffect(() => {
    if (value !== last.current) {
      last.current = value;
      setParts(parseTypeLine(value));
    }
  }, [value]);
  const update = (patch) => {
    const next = { ...parts, ...patch };
    setParts(next);
    last.current = composeTypeLine(next);
    onChange(last.current);
  };
  const toggle = (key) => (word) => update({ [key]: parts[key].includes(word) ? parts[key].filter((w) => w !== word) : [...parts[key], word] });
  return (
    <div className="space-y-3 rounded-lg border border-[#2A3447] bg-black/20 p-4" data-testid={`${prefix}-type-builder`}>
      <Chips label="Supertypes" options={SUPERTYPES} selected={parts.supertypes} onToggle={toggle("supertypes")} testid={`${prefix}-supertype`} />
      <Chips label="Card types" options={CARD_TYPES} selected={parts.types} onToggle={toggle("types")} testid={`${prefix}-cardtype`} />
      <Chips label="Specialty card types (Planechase, Archenemy, Vanguard…)" options={SPECIAL_CARD_TYPES} selected={parts.types} onToggle={toggle("types")} testid={`${prefix}-specialtype`} />
      <div className="grid gap-3 sm:grid-cols-2">
        <div>
          <label className="field-label" htmlFor={`${prefix}-other-types`}>Homebrew super/card types</label>
          <input id={`${prefix}-other-types`} className="field" placeholder="e.g. Relic" value={parts.other} onChange={(e) => update({ other: e.target.value })} data-testid={`${prefix}-other-types-input`} />
        </div>
        <div>
          <label className="field-label" htmlFor={`${prefix}-subtypes`}>Subtypes</label>
          <input id={`${prefix}-subtypes`} className="field" placeholder="Merfolk Wizard" value={parts.subtypes} onChange={(e) => update({ subtypes: e.target.value })} data-testid={`${prefix}-subtypes-input`} />
        </div>
      </div>
    </div>
  );
}
